import React from 'react';
import useIntl from 'react-intl/src/components/useIntl';
import { Button, Table } from 'semantic-ui-react';
import messages from 'src/messages';
import { fieldKindLabel, formatFieldDefault } from './fieldDefinitions';
import './CustomFieldsTable.module.css';

/** Summary of the fields defined for one category. */
export function CustomFieldsTable({
  fields,
  permissionWrite,
  onEdit,
  onDelete,
}: {
  fields: any[];
  permissionWrite: boolean;
  onEdit: (field: any) => void;
  onDelete: (field: any) => void;
}) {
  const { formatMessage } = useIntl();

  if (fields.length === 0) {
    return (
      <p className="custom-fields-table-empty">
        {formatMessage(messages.customFieldEmpty)}
      </p>
    );
  }

  return (
    <Table compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            {formatMessage(messages.customFieldColumnLabel)}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {formatMessage(messages.customFieldColumnType)}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {formatMessage(messages.customFieldColumnDefault)}
          </Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {fields.map((field) => (
          <CustomFieldRow
            key={field.id}
            field={field}
            permissionWrite={permissionWrite}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </Table.Body>
    </Table>
  );
}

function CustomFieldRow({
  field,
  permissionWrite,
  onEdit,
  onDelete,
}: {
  field: any;
  permissionWrite: boolean;
  onEdit: (field: any) => void;
  onDelete: (field: any) => void;
}) {
  const { formatMessage } = useIntl();
  const kindLabel = fieldKindLabel(field.kind);

  return (
    <Table.Row>
      <Table.Cell>{field.name}</Table.Cell>
      <Table.Cell>{kindLabel ? formatMessage(kindLabel) : field.kind}</Table.Cell>
      <Table.Cell>{formatFieldDefault(field, formatMessage)}</Table.Cell>
      <Table.Cell textAlign="right">
        <Button
          icon="edit"
          disabled={!permissionWrite}
          onClick={() => onEdit(field)}
          title={formatMessage(messages.edit)}
        />
        <Button
          icon="trash alternate"
          disabled={!permissionWrite}
          onClick={() => onDelete(field)}
          title={formatMessage(messages.delete)}
        />
      </Table.Cell>
    </Table.Row>
  );
}
